import React, { Component } from "react";
import { withRouter } from 'react-router-dom';

import UI from "../../../actions/ui-helper";
import API from "../../../actions/api-helper";

import "./css/impressao.css";

class ImpressaoProntuario extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  componentDidMount() {
    UI.loader("show", "Aguarde, gerando relatório...");
    API.get("/prontuario/" + this.props.match.params.id)
      .then(function (json) {
        this.setState(json.data);
        UI.loader("hide");
      }.bind(this)).catch(function (json) {
        UI.alert(false, json.message);
      });
  }

  render() {
    if (!this.state.paciente) return false;

    let fontePequena = {
      fontSize: "10px"
    };
    let styleProcedimento = {
      width: "30%"
    };
    let styleLabel = {
      width: "15%",
      fontWeight: "700",
      display: "inline-block"
    };

    // Dados do cabeçalho
    let paciente = this.state.paciente;
    let empresa = this.props.usuario.empresa;
    let endereco = this.props.usuario.empresa.endereco;

    // Renderização da tabela
    return (
      <div className="report">
        <button className="btn btn-primary btn-float-right" onClick={() => window.print()}><i className="icon icon-printer"></i>Preparar para Impressão</button>
        <header className="report-header">
          <h2>{empresa.razaoSocial}</h2>
          <h3>CNPJ: {empresa.cnpj}</h3>
          <hr></hr>
        </header>
        <div className="report-content">
          <p>
            <span style={styleLabel}>Paciente:</span>ID {paciente.idCismepar} - {paciente.nome}<br></br>
            <span style={styleLabel}>CPF:</span>{paciente.cpf !== "" ? paciente.cpf : "NÃO INFORMADO"}<br></br>
            <span style={styleLabel}>Data Nascimento:</span>{paciente.dataNascimento}<br />
            <span style={styleLabel}>Cidade:</span>{paciente.endereco.cidade}</p>
          <br></br>
          <span style={styleLabel}>1. Atendimentos:</span>
          <table className="report-table stretch" style={fontePequena}>
            <thead>
              <tr>
                <th>Data</th>
                <th>Entrada</th>
                <th>Saida</th>
                <th>Total</th>
                <th style={styleProcedimento}>Cód / Procedimento</th>
                <th>Descrição</th>
                <th>Data Nascimento</th>
                <th>Cidade</th>
                <th>ID</th>
                <th>Profissional</th>
                <th>Atendim.</th>
              </tr>
            </thead>
            <tbody>
              {this.state.atendimentos.map(
                (producao, i) => {
                  return <tr key={i}>
                    <td>{producao.data}</td>
                    <td>{producao.horaEntrada.substring(0, 5)}</td>
                    <td>{producao.horaSaida.substring(0, 5)}</td>
                    <td>{producao.horaTotal.substring(0, 5)}</td>
                    <td>{producao.procedimento.codigo} - {producao.procedimento.descricao}</td>
                    <td>{producao.descricao}</td>
                    <td>{producao.paciente ? producao.paciente.dataNascimento : ""}</td>
                    <td>{producao.paciente ? producao.paciente.endereco.cidade : ""}</td>
                    <td>{producao.paciente ? producao.paciente.idCismepar : ""}</td>
                    <td>
                      {producao.valores.map(
                        (valor, i) => {
                          let last = producao.valores.length - 1;
                          let separador = (i + 1) === last ? ' e ' : (i + 1) < last ? ', ' : '';
                          return (<span key={i}>{valor.usuarioNome.toUpperCase()}{separador}</span>);
                        })}
                    </td>
                    <td></td>
                  </tr>
                })}
            </tbody>
          </table>
          <br></br>
          <span style={styleLabel}>2. Reuniões:</span>
          <table className="report-table stretch" style={fontePequena}>
            <thead>
              <tr>
                <th>Data</th>
                <th>Entrada</th>
                <th>Saida</th>
                <th>Total</th>
                <th style={styleProcedimento}>Cód / Procedimento</th>
                <th>Descrição</th>
                <th>Data Nascimento</th>
                <th>Cidade</th>
                <th>ID</th>
                <th>Profissional</th>
                <th>Atendim.</th>
              </tr>
            </thead>
            <tbody>
              {this.state.reunioes.map(
                (producao, i) => {
                  return <tr key={i}>
                    <td>{producao.data}</td>
                    <td>{producao.horaEntrada.substring(0, 5)}</td>
                    <td>{producao.horaSaida.substring(0, 5)}</td>
                    <td>{producao.horaTotal.substring(0, 5)}</td>
                    <td>{producao.procedimento.codigo} - {producao.procedimento.descricao}</td>
                    <td>{"ATA 0" + producao.id}</td>
                    <td>{producao.paciente ? producao.paciente.dataNascimento : ""}</td>
                    <td>{producao.paciente ? producao.paciente.endereco.cidade : ""}</td>
                    <td>{producao.paciente ? producao.paciente.idCismepar : ""}</td>
                    <td>
                      {producao.valores.map(
                        (valor, i) => {
                          let last = producao.valores.length - 1;
                          let separador = (i + 1) === last ? ' e ' : (i + 1) < last ? ', ' : '';
                          return (<span key={i}>{valor.usuarioNome.toUpperCase()}{separador}</span>);
                        })}
                    </td>
                    <td></td>
                  </tr>
                })}
            </tbody>
          </table>
          <br></br>
          <span style={styleLabel}>3. Documentos:</span>
          <table className="report-table stretch" style={fontePequena}>
            <thead>
              <tr>
                <th>Data</th>
                <th>Usuário</th>
                <th>Nome</th>
              </tr>
            </thead>
            <tbody>
              {this.state.documentos.map(
                (documento, i) => {
                  return <tr key={i}>
                    <td>{documento.dataHora}</td>
                    <td>{documento.usuarioNome}</td>
                    <td>{documento.nome}</td>
                  </tr>
                })}
            </tbody>
          </table>
        </div>
        <footer className="report-footer">
          <hr></hr>
          {endereco.logradouro} {endereco.numero} - {endereco.bairro} - cep {endereco.cep}<br />
          {empresa.telefoneComercial} - {empresa.telefoneCelular}<br />
          {empresa.email}<br />
          {endereco.cidade} - {endereco.estado}
        </footer>
      </div>
    );
  }
}

export default withRouter(ImpressaoProntuario);